import { fileCollectionFromZip } from 'filelist-utils';
import { read } from './read';
export async function readZipFile(file, options = {}) {
    const filecollection = await fileCollectionFromZip(await file.arrayBuffer());
    const { nmriumState: { data }, } = await read(filecollection, options);
    return data || { spectra: [], molecules: [] };
}
//# sourceMappingURL=readZip.js.map